import { Injectable, EventEmitter } from '@angular/core';
import { CoreService } from '../core.service';

@Injectable({
	providedIn: 'root'
})
export class ScheduleService {

	constructor( public core: CoreService ){
		this.core.schedule = this;

		this.core.stateshot_synced.subscribe( () => this.stateshot_parse() );
		this.stateshot_parse();

		//Tries to detect timezone mistakes, so ignores any offsets smaller than 10 minutes!
		let now = this.core.stateshot_sync_timestamp || (new Date()).getTime()
		let offset = new Date(this.core.stateshot['meta']['server_time']).getTime() - now;
		if( 1000 * 60 * 15 < Math.abs(offset) )
			this.clock_offset_seconds = offset;

		this.clock_tick_start();
	}
	stateshot_parse(){
		this.tz = this.core.stateshot['meta']['server_tz'];


	}

	//Timezone Stuff
	tz = '-0500'; tz_label = 'ET';
	get tz_offset_milliseconds(){ return +`${this.tz[0]}1000` * (3600*+this.tz.slice(1,3) + 60 * +this.tz.slice(3,5) ) }
	tz_convert_date(date) {
		let new_date = new Date();
		new_date.setTime( new Date(date).getTime() + this.tz_offset_milliseconds );
		return new_date
	}
	utc_offset_date( dt, days, start_of_day = false ) {
		let date = new Date( new Date().setUTCDate( dt.getUTCDate() + days ) );
		if( start_of_day ) date.setUTCHours( 0, 0, 0, 0 );
		return date;
	}


	//Clock ticking
	on_clock_tick: EventEmitter<null> = new EventEmitter(); //Each time a second passes on the clock...

	clock_datetime: Date;
	clock_offset_seconds: number = 0;
	clock_tick_interval = null;
	clock_tick_start(){
		if( this.clock_tick_interval )
			clearInterval( this.clock_tick_interval );

		//Set the clock ticker to tick every second!
		this.clock_tick_interval = setInterval( () => this.clock_tick(), 1000 );
		this.clock_tick();
	}
	clock_tick(){
		this.clock_datetime = new Date(new Date().getTime() + this.clock_offset_seconds);
		this.on_clock_tick.emit();
	}
	get clock_timestamp(){ return this.clock_datetime.getTime() }

	//Humanization
	relative_day_name( dt ){
		let now = this.tz_convert_date( this.clock_datetime );

		let date = this.tz_convert_date( dt );
		date = this.utc_offset_date( date, 0, true );

		let day_names = { "-1": "Yesterday", "0": "Today", "1": "Tomorrow" } //I know, string keys...

		for( let [offset, name] of Object.entries(day_names) ){
			let current_date = this.utc_offset_date( now, +offset, true );
			if( current_date.getTime() == date.getTime() ) return name;
		}

	}
	relative_day_count( date ){
		let now_date = this.utc_offset_date( this.tz_convert_date( this.clock_datetime ), 0, true );
		date = this.utc_offset_date( this.tz_convert_date( date ), 0, true );
		//The Math part is probably not needed
		return Math.floor( ( date.getTime() - now_date.getTime() ) / 86400000 );
	}
	datetimes_on_same_day( dt1, dt2 ){
		dt1 = this.utc_offset_date( this.tz_convert_date( dt1 ), 0, true );
		dt2 = this.utc_offset_date( this.tz_convert_date( dt2 ), 0, true );
		return dt1.getTime() == dt2.getTime();
	}

}
